import { reducerAlert } from './reducers/alert';
import { reducerModal } from './reducers/modals';
import { userReducer } from './user/reducer';

export default {
  reducerModal,
  user: userReducer,
  alert: reducerAlert,
};
